(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-template"]) return;
  try {
    
function getfilter(selectedval){
window.location.href =selectedval;

}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    

 $('#joinclubbtn').click(function(){
 $.cookie("naugthy-newsletter2", "opened", { expires: 7 });             
$('#sonix2signup').animate({height: "0"}, 1000, function() {}).hide();
});
 $('.newsletter-popup').click(function(e){
   e.preventDefault();
$('#sonix2signup').animate({height: "230"}, 1000, function() {}).show();
});                                 
                                  
$(document).ready(function(){
     if($.cookie("naugthy-newsletter2") != 'opened'){
    $('#sonix2signup').animate({height: "230"}, 1000, function() {}).show();
     }                            
    var fixmeTop = $('#shopify-section-header').offset().top;   
        
		$(window).scroll(function() { 
				var currentScroll = $(window).scrollTop(); // get current position
			//  console.log(fixmeTop); console.log(currentScroll);
				if (currentScroll > fixmeTop) {           // apply class fixed
					$('#shopify-section-header').addClass("fixednav");
				} else {                                   // remove class fixed
					$('#shopify-section-header').removeClass("fixednav");
				}
			
		
});
});
 jQuery(window).scroll(function(){ if(jQuery(document).scrollTop() == 0){ jQuery('#scroll-div').hide(); }else{ jQuery('#scroll-div').show(); } });  jQuery('.imghover').bind('mouseenter mouseleave', function() { jQuery(this).attr({ src: jQuery(this).attr('data-other-src') , 'data-other-src': jQuery(this).attr('src') }) });   jQuery("#top").click(function() { jQuery("html, body").animate({ scrollTop: 0 }, "slow"); return false; });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
    jQuery(document).ready(function($){ 
    $(window).scroll(function () {
    var screen_width = screen.width;
    var e = $(window).scrollTop();
    if(screen_width >= 992) {
    if (e > 87) {
    $("header").addClass('navbar-fixed-top');
    } else {
    $("header").removeClass('navbar-fixed-top');
    }
    } else {
    if (e > 120) {
    $("header").addClass('navbar-fixed-top');
    }
    if (e == 0) {
    $("header").removeClass('navbar-fixed-top');
    }
    }
    });
    });
    
  } catch(e) { console.error(e); }
})();
})();
